module.exports = __webpack_public_path__ + "img/0Q3A7086_L_Wood.7550a6f7.jpg";